import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';

@Component({
  selector: 'app-how-to-gs',
  templateUrl: './how-to-gs.component.html',
  styleUrls: ['./how-to-gs.component.css']
})
export class HowToGsComponent implements OnInit {

  gsPage: any
  constructor(private router: Router, private service: AdminService) { }

  ngOnInit(): void {

    this.service.getHowToGS().subscribe(data => {
      this.gsPage = data
    })
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  navigate() {
    this.router.navigate(['cinejoy/premiere/lineup'])
  }
}
